module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-mdx/gatsby-browser.js'),
      options: {"plugins":[],"extensions":[".mdx",".md"],"remarkPlugins":[[null,{"instructions":[{"name":"importDemo"},{"name":"renderInterface"}]}]],"rehypePlugins":[null]},
    }]
